import i18next from '../../i18n';

i18next.t('my.key');

export enum TableHeaders {
    companyName = 'companyName',
    client = 'client',
    invoiceNumber = 'invoiceNumber',
    branchName = 'branchName',
    mainGroup = 'mainGroup',
    vat = 'vat',
    country = 'country',
    city = 'city',
    companyAddress = 'companyAddress',
    address = 'address',
    owner = 'owner',
    warehouseName = 'warehouseName',
    subGroups = 'subGroups',
    users = 'users',
    timeZone = 'timeZone',
    language = 'language',
    roles = 'roles',
    username = 'username',
    name = 'name',
    phone = 'phone',
    email = 'email',
    eik = 'eik',
    created_time = 'createdAt',
    state = 'state',
    comment = 'comment',
    mobileDevice = 'mobileDevice',
    vehicle = 'vehicle',
    isDefective = 'isDefective',
    batchCode = 'batchCode',
    batches = 'batches',
    cost = 'cost',
    deliveryDate = 'deliveryDate',
    log = 'log',
    groupName = 'groupName',
    operation = 'operation',
    passportId = 'passportId',
    type = 'type',
    model = 'model',
    models = 'models',
    power = 'power',
    areaCoverage = 'areaCoverage',
    sprayRange = 'sprayRange',
    waitRange = 'waitRange',
    sapCode = 'sapCode',
    price = 'price',
    justPrice = 'justPrice',
    priceForInvoice = 'priceForInvoice',
    priceForSale = 'priceForSale',
    minimumDeposit = 'minimumDeposit',
    essencePriceGroup = 'essencePriceGroup',
    deviceGroup = 'deviceGroup',
    oilType = 'oilType',
    oilCapacity = 'oilCapacity',
    containerType = 'containerType',
    capacityMl = 'capacityMl',
    availableAmount = 'availableAmount',
    handoutAvailableAmount = 'handoutAvailableAmount',
    batteryVoltage = 'batteryVoltage',
    batteryCapacity = 'batteryCapacity',
    forModel = 'forModel',
    duePaymentDate = 'duePaymentDate',
    fromDate = 'fromDate',
    toDate = 'toDate',
    datePayment = 'datePayment',
    dateDocument = 'dateDocument',
    paid = 'paid',
    totalFee = 'totalFee',
    cash = 'cash',
    fee = 'fee',
    passport = 'passport',
    count = 'count',
    selectedQuantity = 'selectedQuantity',
    selectedCount = 'selectedCount',
    user = 'user',
    dateTime = 'dateTime',
    returnedAt = 'returnedAt',
    date = 'date',
    forBranch = 'forBranch',
    forUser = 'forUser',
    equipment = 'equipment',
    description = 'description',
    town = 'town',
    clientType = 'clientType',
    deviceCount = 'deviceCount',
    countDevices = 'countDevices',
    newDevicesServicedDevices = 'newDevices/servicedDevices',
    paymentType = 'paymentType',
    taskType = 'taskType',
    fromDistributor = 'fromDistributor',
    distributor = 'distributor',
    compiledBy = 'compiledBy',
    fromWarehouse = 'fromWarehouse',
    fromUser = 'fromUser',
    serialNumber = 'serialNumber',
    fiscalBattery = 'fiscalBattery',
    napLastSentAt = 'napLastSentAt',
    healthUpdatedAt = 'healthUpdatedAt',
    lastRefusalAt = 'lastRefusalAt',
    creationDate = 'creationDate',
    documentType = 'documentType',
    invoiceStartNumber = 'invoiceStartNumber',
    invoiceEndNumber = 'invoiceEndNumber',
    receiptStartNumber = 'receiptStartNumber',
    receiptEndNumber = 'receiptEndNumber',
    completionDate = 'completionDate',
    consumables = 'consumables',
    invoicePrice = 'invoicePrice',
    emailSentDate = 'emailSentDate',
    paymentProcessingStatus = 'paymentProcessingStatus',
    documentNumber = 'documentNumber',
    supplierName = 'supplierName',
    totalQuantity = 'totalQuantity',
    totalDeliveryPrice = 'totalDeliveryPrice',
    quantity = 'quantity',
    deliveryPrice = 'deliveryPrice',
    passportName = 'passportName',
}

export const companiesTableHeaders = [
    TableHeaders.name,
    TableHeaders.phone,
    TableHeaders.companyAddress,
    TableHeaders.clientType,
    TableHeaders.vat,
    TableHeaders.owner,
];

export const fiscalDevicesTableHeaders = [
    TableHeaders.serialNumber,
    TableHeaders.user,
    TableHeaders.invoiceStartNumber,
    TableHeaders.invoiceEndNumber,
    TableHeaders.receiptStartNumber,
    TableHeaders.receiptEndNumber,
    TableHeaders.fiscalBattery,
    TableHeaders.napLastSentAt,
    TableHeaders.healthUpdatedAt,
    TableHeaders.lastRefusalAt,
];

export const invoicesTableHeaders = [
    TableHeaders.invoiceNumber,
    TableHeaders.creationDate,
    TableHeaders.documentType,
    TableHeaders.branchName,
    TableHeaders.companyName,
    TableHeaders.vat,
    TableHeaders.fromDate,
    TableHeaders.toDate,
    TableHeaders.fromDistributor,
    TableHeaders.totalFee,
    TableHeaders.paymentType,
    TableHeaders.paymentProcessingStatus,
];

export const sentInvoicesTableHeaders = [
    ...invoicesTableHeaders,
    TableHeaders.emailSentDate,
];

export const SalesTableHeaders = [
    TableHeaders.invoiceNumber,
    TableHeaders.creationDate,
    TableHeaders.documentType,
    TableHeaders.companyName,
    TableHeaders.vat,
    TableHeaders.fromDistributor,
    TableHeaders.totalFee,
    TableHeaders.paymentType,
    TableHeaders.paymentProcessingStatus,
];

export const sentSalesTableHeaders = [
    ...SalesTableHeaders,
    TableHeaders.emailSentDate,
];

export const invoicesToDocumentTableHeaders = [
    TableHeaders.invoiceNumber,
    TableHeaders.creationDate,
    TableHeaders.documentType,
    TableHeaders.branchName,
    TableHeaders.fromDate,
    TableHeaders.toDate,
    TableHeaders.fromDistributor,
    TableHeaders.fee,
    TableHeaders.paymentType,
];
export const turnoverTableHeaders = [
    TableHeaders.type,
    TableHeaders.invoiceNumber,
    TableHeaders.branchName,
    TableHeaders.companyName,
    TableHeaders.vat,
    TableHeaders.distributor,
    TableHeaders.compiledBy,
    TableHeaders.deviceCount,
    TableHeaders.fromDate,
    TableHeaders.toDate,
    TableHeaders.dateDocument,
    TableHeaders.cash,
    TableHeaders.paymentType,
    TableHeaders.taskType,
];

export const invoicelessDocumentsTableHeaders = [
    TableHeaders.type,
    TableHeaders.invoiceNumber,
    TableHeaders.branchName,
    TableHeaders.companyName,
    TableHeaders.vat,
    TableHeaders.user,
    TableHeaders.dateDocument,
    TableHeaders.cash,
    TableHeaders.paymentType,
];

export const allDocumentsTableHeaders = [
    TableHeaders.type,
    TableHeaders.invoiceNumber,
    TableHeaders.user,
    TableHeaders.dateDocument,
    TableHeaders.cash,
    TableHeaders.paymentType,
];

export const usersTableHeaders = [
    TableHeaders.username,
    TableHeaders.roles,
    TableHeaders.mainGroup,
    TableHeaders.subGroups,
    TableHeaders.town,
    TableHeaders.name,
    TableHeaders.phone,
    TableHeaders.email,
    TableHeaders.created_time,
    TableHeaders.comment,
];

// Само за активните потребители - при замразените телефонът няма смисъл.
export const usersWithDeviceTableHeaders = [...usersTableHeaders, TableHeaders.mobileDevice, TableHeaders.vehicle];

export const groupsTableHeaders = [
    TableHeaders.mainGroup,
    TableHeaders.subGroups,
    TableHeaders.timeZone,
    TableHeaders.language,
];

export const warehousesTableHeaders = [
    TableHeaders.warehouseName,
    TableHeaders.type,
    TableHeaders.mainGroup,
    TableHeaders.subGroups,
];

export const batchesTableHeaders = [
    TableHeaders.passport,
    TableHeaders.batchCode,
    TableHeaders.cost,
    TableHeaders.deliveryDate,
    TableHeaders.isDefective,
];

export const batchQuantitiesTableHeaders = [
    TableHeaders.passport,
    TableHeaders.count,
    TableHeaders.cost,
    TableHeaders.deliveryDate,
];

export const handoutTableHeaders = [
    TableHeaders.passport,
    TableHeaders.count,
    TableHeaders.forBranch,
    TableHeaders.forUser,
];
export const completedHandoutTableHeaders = [
    TableHeaders.passport,
    TableHeaders.batchCode,
    TableHeaders.count,
    TableHeaders.forUser,
    TableHeaders.distributor,
    TableHeaders.price,
    TableHeaders.deliveryDate,
    TableHeaders.state,
];

export const quantitiesTableHeader = [
    TableHeaders.passport,
    TableHeaders.count,
    TableHeaders.availableAmount,
    TableHeaders.user,
    TableHeaders.deliveryDate,
    TableHeaders.dateTime,
    TableHeaders.equipment,
    TableHeaders.sapCode,
];

export const shortQuantitiesTableHeader = [
    TableHeaders.passport,
    TableHeaders.count,
    TableHeaders.availableAmount,
    TableHeaders.batchCode,
    TableHeaders.cost,
    TableHeaders.username,
    TableHeaders.sapCode,
    TableHeaders.state,
];

export const consumedResourcesTableHeaders = [
    TableHeaders.documentNumber,
    TableHeaders.supplierName,
    TableHeaders.created_time,
    TableHeaders.totalQuantity,
    TableHeaders.totalDeliveryPrice,
];

export const consumedResourcesItemsTableHeaders = [
    TableHeaders.description,
    TableHeaders.passportName,
    TableHeaders.batchCode,
    TableHeaders.deliveryPrice,
    TableHeaders.quantity,
];

export const shortHandoutQuantities = [
    TableHeaders.passport,
    TableHeaders.batchCode,
    TableHeaders.count,
];

export const shortHandoutQuantitiesWithSelectedTableHeader = [
    TableHeaders.passport,
    TableHeaders.batchCode,
    TableHeaders.state,
    TableHeaders.count,
    TableHeaders.handoutAvailableAmount,
    TableHeaders.selectedCount,
];

export const inventoryTableHeaders = [
    TableHeaders.passport,
    TableHeaders.batches,
    TableHeaders.count,
    TableHeaders.availableAmount,
];

export const inventoryCollapsedTableHeaders = [
    TableHeaders.passport,
    TableHeaders.count,
    TableHeaders.batchCode,
    TableHeaders.state,
];

export const scrapTableHeaders = [
    TableHeaders.passport,
    TableHeaders.batchCode,
    TableHeaders.count,
    TableHeaders.fromDistributor,
    TableHeaders.dateTime,
];

export const referencesDistributorTableHeaders = [
    TableHeaders.passport,
    // TableHeaders.batchCode,
    TableHeaders.state,
    TableHeaders.count,
];
export const referencesDistributorInnerTableHeaders = [
    TableHeaders.passport,
    TableHeaders.batchCode,
    TableHeaders.state,
    TableHeaders.count,
];

export const referencesWarehouseHandOut = [
    TableHeaders.passport,
    TableHeaders.count,
];

export const referencesInnerWarehouseHandOut = [
    TableHeaders.passport,
    TableHeaders.batchCode,
    TableHeaders.count,
    TableHeaders.fromUser,
    TableHeaders.forUser,
];

export const referencesWarehouseScraps = [
    TableHeaders.passport,
    TableHeaders.count,
];


export const referencesInnerWarehouseScraps = [
    TableHeaders.passport,
    TableHeaders.batchCode,
    TableHeaders.count,
    TableHeaders.fromDistributor,
];

export const referencesWarehouseDelivers = [
    TableHeaders.passport,
    TableHeaders.count,
];

export const referencesInnerWarehouseDelivers = [
    TableHeaders.passport,
    TableHeaders.batchCode,
    TableHeaders.count,
    TableHeaders.fromWarehouse,
];

export const referencesTableHeaders = [
    TableHeaders.passport,
    TableHeaders.count
];

export const referencesInnerTableHeaders = [
    TableHeaders.passport,
    TableHeaders.count,
    TableHeaders.batchCode
];

export const inventoryQuantitiesTableHeaders = [...referencesTableHeaders, TableHeaders.state, TableHeaders.user];

export const userInventoriesTableHeaders = [TableHeaders.username, TableHeaders.groupName];
export const handoverProtocolsTableHeaders = [TableHeaders.fromDistributor, TableHeaders.date, TableHeaders.client, TableHeaders.address, TableHeaders.phone, TableHeaders.taskType, TableHeaders.deviceCount, TableHeaders.justPrice];
export const handoverProtocolsShortTableHeaders = [TableHeaders.client, TableHeaders.branchName, TableHeaders.address, TableHeaders.type, TableHeaders.count, TableHeaders.models, TableHeaders.distributor, TableHeaders.date];

export const logsTableHeaders = [
    TableHeaders.username,
    TableHeaders.created_time,
    TableHeaders.groupName,
    TableHeaders.log,
    TableHeaders.operation,
];

export const passportTableHeaders = [TableHeaders.name, TableHeaders.price, TableHeaders.priceForInvoice, TableHeaders.priceForSale];

export const devicePassportTableHeaders = [
    ...passportTableHeaders,
    TableHeaders.deviceGroup,
    TableHeaders.model,
    TableHeaders.power,
    TableHeaders.areaCoverage,
    TableHeaders.sprayRange,
    TableHeaders.waitRange,
];
export const consumablePassportTableHeaders = [...passportTableHeaders, TableHeaders.essencePriceGroup, TableHeaders.forModel, TableHeaders.type];
export const otherPassportTableHeaders = [...passportTableHeaders, TableHeaders.description];
export const containerPassportTableHeaders = [...passportTableHeaders, TableHeaders.containerType, TableHeaders.capacityMl];

export const referencesDistributorTasksTableHeaders = [
    TableHeaders.completionDate,
    TableHeaders.taskType,
    TableHeaders.branchName,
    TableHeaders.client,
    TableHeaders.countDevices,
    TableHeaders.consumables,
    TableHeaders.invoicePrice,
    TableHeaders.paymentType,
    TableHeaders.state,
];
